export default {
  title: {
    nl: 'Oops... Something went wrong'
  },

  retry: {
    nl: 'Please try again later.'
  }
};
